/**
 * A loader's fetch, handed to the page unawaited. A loader that awaits holds the
 * navigation — sidebar click, URL, page — until every request is back; returning the
 * promise lets the page switch at once and render `<Deferred>` while it loads.
 *
 * A page left before its data arrives never reads the promise, so a rejection is
 * marked handled here; `<Deferred>` still sees it.
 */
export function deferred<T>(promise: Promise<T>): Promise<T> {
  promise.catch(() => undefined);
  return promise;
}
